import { render, staticRenderFns } from "./get-area.vue?vue&type=template&id=b66ab540&scoped=true"
import script from "./get-area.vue?vue&type=script&lang=js"
export * from "./get-area.vue?vue&type=script&lang=js"
import style0 from "./get-area.vue?vue&type=style&index=0&id=b66ab540&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66ab540",
  null
  
)

export default component.exports